var devices = {

    //DEVICES
    async patch(device) {
        if(window.debug)console.log("dao:saveDevice:")
        const db = window.firebase.firestore();
        var ref = db.collection("databases/" + window.eid + "/devices")
        var e = await ref.doc(device.id).set(device)
            .then((docRef) => {
                if(window.debug)console.log("Document successfully updated!" + JSON.stringify(docRef));
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        return device;

    },

    async upsert(device) {
        //var d = Object.assign({}, device)
        var d = JSON.parse(JSON.stringify(device));
       //alert(JSON.stringify(d));
        //If there'is a deviceId, save , otherwise, add
        if (d.id) {
            var a = await this.patch(d);
            //alert(JSON.stringify(a))
            return a;
        }
        if(window.debug)console.log(JSON.stringify(d))
        const db = window.firebase.firestore();
        var ref = db.collection("databases/" + window.eid + "/devices")
        var e = await ref.add(d)
            .then((docRef) => {
                if(window.debug)console.log("Document successfully created!");
                return docRef;
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });
        d.id = e.id;
    
        var a = await this.patch(d);
        return d;
    },

    async getAll(manufacturer, deviceType, available) {
        if(window.debug)console.log("will get devices")
        const db = window.firebase.firestore();
        let objects = [];
        var ref = db.collection("databases/" + window.eid + "/devices");
        if (manufacturer !== "*")
            ref = ref.where("manufacturer", "==", manufacturer)

        if (deviceType !== "*")
            ref = ref.where("deviceType", "==", deviceType)

        if (available)
            ref = ref.where("product.available", "==", true)
        
        //ref = ref.orderBy("dcPower");
        var ans = await ref
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()

                    );
                     if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        // for (var a = 0; a < ans.length; a++)
        //   ans[a].enterprise = await this.getEnterprise(ans[a].window.eid)
        return ans;
    },

    async getFromId(deviceId) {
        const db = window.firebase.firestore();
        let objects = [];
        var ans = db.collection("databases/" + window.eid + "/devices").where("id", "==", deviceId)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()
                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        return ans;
    },

    async getFromCode(code, manufacturer) {
        if(window.debug)console.log("will get devices code:" + code)
        if(window.debug)console.log("will get devices manufacturer :" + manufacturer)
        const db = window.firebase.firestore();
        let objects = [];
        var ans = db.collection("databases/" + window.eid + "/devices").where("code", "==", code).where("manufacturer", "==", manufacturer)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()

                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        // for (var a = 0; a < ans.length; a++)
        //   ans[a].enterprise = await this.getEnterprise(ans[a].window.eid)

        if(window.debug)console.log(JSON.stringify(ans))
        return ans;
    },

    async delete(deviceId) {
        if(window.debug)console.log("will get devices")
        const db = window.firebase.firestore();
        let objects = [];
        var ans = db.collection("databases/" + window.eid + "/devices").doc(deviceId)
            .delete()
            .then(() => {

                if(window.debug)console.log("Device deleted")
                return "ok"
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        // for (var a = 0; a < ans.length; a++)
        //   ans[a].enterprise = await this.getEnterprise(ans[a].window.eid)
        return ans;
    },

    async getAllModules() {
        if(window.debug)console.log("will get devices")
        const db = window.firebase.firestore();
        let objects = [];
        var ans = db.collection("databases/" + window.eid + "/devices").where("deviceType", "==", "module")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()
                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });
        // for (var a = 0; a < ans.length; a++)
        //   ans[a].enterprise = await this.getEnterprise(ans[a].window.eid)
        return ans;
    },

    async getInverters(manufacturer, phases) {
        if(window.debug)console.log("will get devices:" + window.eid + ", phases: " + phases)
        const db = window.firebase.firestore();
        let objects = [];
        var ans = await db.collection("databases/" + window.eid + "/devices").where("manufacturer", "==", manufacturer)
            .where("acPhases", "<=", phases)
            .where("deviceType", "==", "inverter").where("product.available", "==", true)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    objects.push(
                        doc.data()

                    );
                    if(window.debug)console.log(doc.id, " => ", doc.data());
                });
                for (var a = 0; a < objects.length; a++)

                    if(window.debug)console.log("will return")
                return objects
            })
            .catch((error) => {
                if(window.debug)console.log("Error getting documents: ", error);
                return error;
            });

        return ans;
    },


}

export default devices;